import { createVuetify } from "vuetify";
import { es } from "vuetify/locale";
import "@mdi/font/css/materialdesignicons.css";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import PerfectScrollbar from "vue3-perfect-scrollbar";
// import VueTablerIcons from '@tabler/icons-vue';
import VueTablerIcons from "vue-tabler-icons";
//Mock Api data

import Vue3Lottie from "vue3-lottie";
import "@/assets/scss/style.scss";

// Table
import Vue3EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";

//i18
import { createI18n } from "vue-i18n";
import messages from "@/utils/locales/messages";

//Mock Api data
import "../_mockApis";

import { ORANGE_THEME } from "@/theme/LightTheme";
import { DARK_ORANGE_THEME } from "@/theme/DarkTheme";

if (localStorage.getItem('primaryColor') !== null && localStorage.getItem('primaryColor') !== 'undefined'){
  ORANGE_THEME.colors.accent = localStorage.getItem('primaryColor', '#5D87FF');
  DARK_ORANGE_THEME.colors.accent = localStorage.getItem('primaryColor', '#5D87FF');
}

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    ssr: false,
    //blueprint: md3,
    components: {
      // draggable: VueDraggableNext,
      ...components,
    },
    directives,
    locale: {
      locale: "es",
      fallback: "es",
      messages: { es },
    },
    theme: {
      defaultTheme: "ORANGE_THEME",
      variations: {
        colors: ['primary', 'secondary', 'grey', 'success', 'warning', 'error', 'white'],
        lighten: 5,
        darken: 5,
      },
      themes: {
        ORANGE_THEME,
        DARK_ORANGE_THEME,
      },
    },
    defaults: {
      VLabel: {
        style: 'font-weight: 600 !important'
      },
      VCard: {
        rounded: "lg",
        elevation: 0,
        style: 'background-color: rgb(var(--v-theme-containerBg))'
      },
      VOverlay: {
        scrim: 'surface'
      },
      VSkeleton: {
        scrim: 'surface'
      },
      VTextField: {
        variant: "outlined",
        density: "comfortable",
        color: "primary",
      },
      VTextarea: {
        variant: "outlined",
        density: "comfortable",
        color: "primary",
      },
      VSelect: {
        variant: "outlined",
        density: "comfortable",
        color: "primary",
        noDataText: "No se encuentra",
      },
      VAutocomplete: {
        variant: "outlined",
        density: "comfortable",
        color: "primary",
        noDataText: "No se encuentra",
      },
      VCombobox: {
        variant: "outlined",
        density: "comfortable",
        color: "primary",
        noDataText: "No se encuentra",
      },
      VListItem: {
        minHeight: "45px",
      },
      VTooltip: {
        location: "top",
      },
      VBtn: {
        style: "text-transform: capitalize; letter-spacing:0",
        rounded: "xl",
      },
    },
  });

  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: "es",
    messages: messages,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
  });
  nuxtApp.vueApp.use(vuetify);
  nuxtApp.vueApp.component("EasyDataTable", Vue3EasyDataTable);
//   nuxtApp.vueApp.use(PerfectScrollbarPlugin);
  
  
  nuxtApp.vueApp.use(PerfectScrollbar);
  nuxtApp.vueApp.use(VueTablerIcons);
  nuxtApp.vueApp.use(VueTelInput);
  nuxtApp.vueApp.use(i18n);
  nuxtApp.vueApp.use(Vue3Lottie)
});
